###
Common Klaviyo functionality
###

klaviyoSDK = '//www.klaviyo.com/media/js/public/klaviyo_subscribe.js'

export default

	mounted: ->
		return if @klaviyoDisabled
		unless klaviyo? and KlaviyoSubscribe?
			await @$loadScript klaviyoSDK, defer: true
		@onKlaviyoLoad()

	computed:
		klaviyoDisabled: -> process.env.KLAVIYO_DISABLE == 1

		klaviyoId: -> switch process.env.CMS_SITE
			when 'brand' then 'Vsr2Xa'
			when 'kitchen' then 'REGZZa'
			when 'cbd', 'hemp' then 'UwTdf3'
			when 'select' then 'SK7wjV'

		klaviyoClass: -> "klaviyo_gdpr_embed_#{@klaviyoId}"

	methods:
		# Empty Klaviyo Load to prevent errors
		onKlaviyoLoad: -> return
